/**
 * MembershipTempl Template
 * @category testApp
 */
class MembershipTempl {
	/**
	 * Sub1 Templ
	 * @param  {Object} _d={}
	 */
	static getTempl(_d={}, _membershipBenefit ='' , _nshopDomain ='') {

		if(_d.level >= 0 ) { // 1. 가입 됨
		//	console.log( '멤버십 가입  ' );
			if(_d.activation == false && _d.remainTimeSec <= 0 ) { // 1-1. 만료

				//let _nshopUrl = ( _membershipBenefit.serverType == 'frontierserver') ?  `https://${window._serviceEnv=="RC" ? "rc-" : "" }bnsnshop.plaync.com/bnsr/goods/detail?dgi=408072` : `https://${window._serviceEnv=="RC" ? "rc-" : "" }bnsnshop.plaync.com/bns/goods/detail?dgi=305545`;
				let _nshopUrl = `https://${window._serviceEnv=="RC" ? "rc-" : "" }store.plaync.com/store/bns/goods/A4906C25-4263-4B34-9F7C-0C4C1A7F1C8D`;

				return `
					<div class="nodata">
						<p>소울 멤버십이 비활성화된 상태입니다.</p>
						${(_membershipBenefit.serverType != 'frontierserver') ? '<a class="link" href="'+_nshopUrl+'">소울멤버십 활성화 하기 </a>':''}	
						
					</div>
					${MembershipTempl.getBenefit(_membershipBenefit,_nshopDomain)}
				`;
			} else { // 1-2. 활성화
			    if(_d.level < 10){
                    return `
					<span class="membership-time">${MembershipTempl.getRemainTime(_d.remainTimeSec)} <!--16일 2시간 남음--> </span>
					<div class="membership-level">
						${MembershipTempl.getTemplLevelPolicies(_d.level, _d.levelPolicies, _d.levelScore)}
						<div class="membership-level-size"><span class="current">LV.${_d.level}</span><span class="next">LV.${_d.level+1}</span></div>
					</div>
					<div class="membership-godstone">
						<h3 class="title">신석 지급량</h3>
						<div class="count"><strong class="current">${_d.dailyReward}개</strong><span class="total">/${_d.maxReward}개</span></div>
					</div>
					${MembershipTempl.getBenefit(_membershipBenefit,_nshopDomain)}
				`;
                }else{ // MAX 레벨일때
                    return `
					<span class="membership-time">${MembershipTempl.getRemainTime(_d.remainTimeSec)} <!--16일 2시간 남음--> </span>
					<div class="membership-level">
						<div class="membership-level-progress">
                            <span class="bar" style="width:100%"></span>
                            <span class="count"><strong class="active">MAX</strong></span>
                        </div>
						<div class="membership-level-size"><span class="current">LV.${_d.level}</span></div>
					</div>
					<div class="membership-godstone">
						<h3 class="title">신석 지급량</h3>
						<div class="count"><strong class="current">${_d.dailyReward}개</strong><span class="total">/${_d.maxReward}개</span></div>
					</div>
					${MembershipTempl.getBenefit(_membershipBenefit,_nshopDomain)}
				`;
                }
			}

		} else { // 2. 가입 안됨
			// console.log( '멤버십 가입 안 함 ' );
			return `
				${MembershipTempl.noData(_membershipBenefit,_nshopDomain)}
			`;
		}

	}

	static getRemainTime(_sec){
		const sec = parseInt(_sec, 10);
		const d = Math.floor(sec/(60 * 60 * 24));
		const h = Math.floor((sec%(60 * 60 * 24)/3600));
		const m = Math.floor((sec%3600)/60);
		const s = sec - (h * 3600) - (m * 60);
		return `${d}일 ${h}시간 ${m}분 남음`;
	}
	static getTemplLevelPolicies(_level, _levelPolicies, _levelScore ) {

		const levelPolicies = _levelPolicies.filter(a=>a.levelId==_level);
		const levelPercentage = Math.floor((_levelScore - levelPolicies[0].minLevelScore)/(levelPolicies[0].maxLevelScore-levelPolicies[0].minLevelScore)*100);
   // console.log(levelPercentage)
		return `
		<div class="membership-level-progress">
			<span class="bar" style="width:${levelPercentage}%"></span>
			<span class="count"><strong class="active">${_levelScore}</strong>/${levelPolicies[0].maxLevelScore}</span>
		</div>`;
	}

	static getBenefit(_benefit) {
		/* 
		@todo 프론티어 대응 완료
		<span class="flag">
			<span class="flag-${_benefit.serverType}">${(_benefit.serverType == 'frontierserver') ? '프론티어':'라이브'}</span>
		</span>
		*/
		return `
		<div class="membership-benefit">
			<h3 class="title">${_benefit.header}</h3>
			
			${(_benefit.serverType == 'liveserver') ? '<a class="more" href="'+_benefit.url+'"><span class="blind">more</span></a>':''}	
			<ul class="membership-benefit-list">
				<li class="membership-benefit-item"><img class="thumb" src="${_benefit.thumb1}"> ${_benefit.subject1}</li>
				<li class="membership-benefit-item"><img class="thumb" src="${_benefit.thumb2}"> ${_benefit.subject2}</li>
			</ul>
		</div>`;
	}

	static noData(_membershipBenefit,_nshopDomain) {
		return `
			<div class="nodata">
				<p>소울 멤버십을 한번도 경험해보지 않으셨나요?<br> 대협을 위한 특별한 혜택을 확인하세요.</p>
				<a class="link" href="${_nshopDomain}/goods/A4906C25-4263-4B34-9F7C-0C4C1A7F1C8D">소울멤버십 활성화 하기 </a>
			</div>
			${MembershipTempl.getBenefit(_membershipBenefit)}`;
	}

} // end of class

export default MembershipTempl;
